import useToggleSdkContext from 'utils/useToogleSdk'

const useAppealRollback = () => {
  const toggles = useToggleSdkContext()
  const isEnabled = toggles?.['kinerja-gpk-appeal-rollback-enabled'] === true

  return {
    isAppealRollbackEnabled: isEnabled,
  }
}

export default useAppealRollback
